module.exports = __webpack_public_path__ + "static/media/YF17_3.d92cb3b3.jpg";